import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconUploadLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.33337 7.4375C2.575 7.4375 2.77087 7.63338 2.77087 7.875V11.375C2.77087 11.4555 2.83617 11.5208 2.91671 11.5208H11.0834C11.1639 11.5208 11.2292 11.4555 11.2292 11.375V7.875C11.2292 7.63338 11.4251 7.4375 11.6667 7.4375C11.9083 7.4375 12.1042 7.63338 12.1042 7.875V11.375C12.1042 11.9388 11.6472 12.3958 11.0834 12.3958H2.91671C2.35292 12.3958 1.89587 11.9388 1.89587 11.375V7.875C1.89587 7.63338 2.09175 7.4375 2.33337 7.4375Z",
		fill: "#A855F7"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.00004 1.60425C7.11785 1.60425 7.23068 1.65176 7.313 1.73603L10.2297 4.72184C10.3985 4.89468 10.3953 5.17167 10.2224 5.34051C10.0496 5.50935 9.77259 5.50611 9.60375 5.33327L7.43754 3.11571V9.62508C7.43754 9.86671 7.24167 10.0626 7.00004 10.0626C6.75842 10.0626 6.56254 9.86671 6.56254 9.62508V3.11571L4.39634 5.33327C4.22749 5.50611 3.9505 5.50935 3.77766 5.34051C3.60482 5.17167 3.60157 4.89468 3.77041 4.72184L6.68708 1.73603C6.7694 1.65176 6.88223 1.60425 7.00004 1.60425Z",
		fill: "#A855F7"
	})]
});
export default SvgIconUploadLine;
